module.exports = __webpack_public_path__ + "media/house.ed0b0a48.mp4";